import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M23.6,11.19l-4-3A1,1,0,0,0,18,9v1.25a.25.25,0,0,1-.25.25h-4a.25.25,0,0,1-.25-.25v-4A.25.25,0,0,1,13.75,6H15a1,1,0,0,0,.8-1.6l-3-4a1,1,0,0,0-1.6,0l-3,4A1,1,0,0,0,9,6h1.25a.25.25,0,0,1,.25.25v4a.25.25,0,0,1-.25.25h-4A.25.25,0,0,1,6,10.24V9a1,1,0,0,0-1.6-.8l-4,3A1,1,0,0,0,0,12a1,1,0,0,0,.4.8l4,3a1,1,0,0,0,1,.09A1,1,0,0,0,6,15V13.74a.25.25,0,0,1,.25-.25h4a.25.25,0,0,1,.25.25v4a.25.25,0,0,1-.25.25H9a1,1,0,0,0-.89.55,1,1,0,0,0,.09,1.05l3,4a1,1,0,0,0,1.6,0l3-4a1,1,0,0,0,.09-1.05A1,1,0,0,0,15,18H13.75a.25.25,0,0,1-.25-.25v-4a.25.25,0,0,1,.25-.25h4a.25.25,0,0,1,.25.25V15a1,1,0,0,0,.55.89,1,1,0,0,0,1.05-.09l4-3A1,1,0,0,0,24,12,1,1,0,0,0,23.6,11.19Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }